export default __webpack_public_path__ + "static/media/ic_notification_active.c7840cb9.svg";